import React, { useMemo } from "react";
import { isImage, StorageFile } from "api/model";
import { Box, IconButton, Link } from "@material-ui/core";
import { CloudDownload, Delete } from "@material-ui/icons";
import { FileUpload, FileUploadProps } from "ui/componentes/FileUpload";
import { useDeleteFile } from "api/hooks/useDeleteFile";
import { useFormikContext } from "formik";

interface FileVisualizerProps {
    label?: string;
    file?: StorageFile;
    maxWidth?: string;
    maxHeight?: string;
    alt?: string;
    onDelete?: () => void;
    uploadProps: FileUploadProps;
}

const FileVisualizer: React.FC<FileVisualizerProps> = ({
    label = "File",
    alt = "alt-file",
    file,
    maxWidth = "100%",
    maxHeight = "80px",
    onDelete,
    uploadProps,
}) => {
    let imageType = useMemo(() => isImage(file), [file]);
    const deleteFile = useDeleteFile();
    const { setFieldValue } = useFormikContext();

    return (
        <fieldset
            style={{
                fontSize: "0.75rem",
                borderWidth: 1,
                borderRadius: 4,
                color: "rgba(0, 0, 0, 0.54)",
                font: "inherit",
            }}
        >
            <legend>
                <span>{label}</span>
            </legend>
            <Box display="flex" flexDirection="column" alignItems="center">
                {imageType && file ? (
                    <img
                        key="image"
                        src={file.downloadURL}
                        style={{
                            maxWidth,
                            maxHeight,
                        }}
                        alt={alt}
                    />
                ) : null}
                <Box>
                    {file && file.downloadURL ? (
                        <Link
                            component={IconButton}
                            key="link"
                            target="_blank"
                            href={file.downloadURL}
                            rel="noreferrer"
                        >
                            <CloudDownload
                                titleAccess={
                                    imageType
                                        ? "Baixar arquivo"
                                        : file.originalFileName
                                }
                            />
                        </Link>
                    ) : null}
                    {file && file.fullPath ? (
                        <IconButton
                            onClick={() => {
                                deleteFile(file, { onDelete }).then(() =>
                                    setFieldValue(uploadProps.name, null)
                                );
                            }}
                            color="secondary"
                        >
                            <Delete />
                        </IconButton>
                    ) : null}
                </Box>
                <FileUpload {...uploadProps} />
            </Box>
        </fieldset>
    );
};

export { FileVisualizer };
